<template>
  <div id="index">
    <!-- 头部 -->
    <HeaderTop :headIndex="head_index" ref="header"></HeaderTop>
    <div class="main wrap flex_between">
      <!-- 报名表单 -->
      <div class="activitiesForm">
        <div class="div_li">
          <h5 class="form_title">基本信息<span class="f_title">（请正确填写信息）</span></h5>
          <div class="form_div">
            <div class="form_input flex_start">
              <div class="input_title"><span>姓 名</span>：</div>
              <div class="input_div">
                <input type="text" maxlength="20" v-model="name" />
              </div>
            </div>
            <div class="form_input flex_start">
              <div class="input_title"><span>手机号</span>：</div>
              <div class="input_div">
                <input type="number" oninput="if(value.length>11)value=value.slice(0,11)" v-model="mobile" />
              </div>
            </div>
            <div class="form_input flex_start">
              <div class="input_title"><span>医 院</span>：</div>
              <div class="input_div">
                <input type="text" maxlength="50" v-model="hospital" />
              </div>
            </div>
          </div>
        </div>
        <div class="div_li">
          <h5 class="form_title">上传图片作品</h5>
          <div class="img_div form_div flex_start">
            <i class="img_li flex_center" v-for="(liem, index) in image" :key="index">
              <div class="flex_center img_li_div li_r_img">
                <img :src="liem" alt="" />
              </div>
              <i class="end_icon" @click="endFun(index)"><img src="@/assets/img/shutDown.png" alt="" /></i>
            </i>
            <i class="img_li" v-if="image.length < 4">
              <input type="file" class="inp_img" @change="handleChange" id="imgInp" ref="inputer" multiple
                accept="image/*" />
              <img src="@/assets/img/add_icon.jpg" alt="" /></i>
          </div>
          <div class="describe">
            注：第一张为封面图，最多上传4张图片，每张小于10M
          </div>
        </div>

        <div class="div_li">
          <h5 class="form_title input_title">描 述</h5>
          <div class="text_div form_div">
            <div class="form_input flex_start">
              <div class="input_title"><span>标题</span>：</div>
              <div class="input_div">
                <input type="text" maxlength="50" v-model="title" />
              </div>
            </div>
            <div class="textarea_div flex_center">
              <textarea name="" maxlength="200" v-model="content" placeholder="添加描述..." id="" cols="30" rows="10"></textarea>
            </div>
          </div>
        </div>
        <div class="button_div flex_end">
            <button class="submit flex_center" @click="submit">
              <span>提交</span>
            </button>
            <button class="submit flex_center return" @click="shutDown">
              <span>返回</span>
            </button>
        </div>
      </div>
      <!-- 热门 -->
      <div class="hot_div hot">
        <div class="hot_title flex_center">
          <i><img src="@/assets/img/hot.png" alt="" /></i>
          <span class="flex_center">热门</span>
        </div>
        <div class="">
          <hot :list="hotList_arr" @detailsFun="detailsFun"></hot>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
  import Footer from "@/components/assembly/Footer.vue"; //尾部模块
  import hot from "@/components/assembly/hot.vue"; //热门模块
  import "@/assets/js/currency.js";
  import "@/assets/css/reset.css";
  import "@/assets/css/pcsinaFaceAndEffec.css";

  export default {
    name: "index",
    data() {
      return {
        name: "",
        mobile: "",
        hospital: "",
        title: "",
        content: "",
        image: [],
        hotList_arr: [], //热门，
        id: 0, //推文id
        head_index: 1, //
      };
    },
    computed: {},
    components: {
      HeaderTop,
      Footer,
      hot,
    },
    props: {},
    watch: {},
    methods: {
      //   清空
      empty() {
        this.name = '';
        this.mobile = '';
        this.hospital = '';
        this.title = '';
        this.content = '';
        this.image = [];

      },
      //   提交作品
      submit() {
        if (!this.judge()) {
          return false;
        }
        let that = this;
        let data = {
          name: this.name,
          mobile: this.mobile,
          hospital: this.hospital,
          title: this.title,
          content: this.content,
          image: this.image.join(","),
          member_id: this.USER().id,
        };
         

        var layerOpen = layer.open({
          type: 2,
          content: "提交中。。。",
        });

        this.$post("activity-add", data)
          .then((res) => {
            layer.close(layerOpen);
            layer.open({
              content: res.msg,
              time: 1.5,
              skin: "msg",
            });
            that.empty();
            setTimeout(() => {

              that.shutDown();
            }, 1500)
          })
          .catch((error) => {
            layer.close(layerOpen);
            layer.open({
              content: error.message,
              time: 2,
              skin: "msg",
            });
          });
      },
      // 判断
      judge() {
        if (this.name == "" || !this.name) {
          layer.open({
            content: "请输入姓名!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.mobile == "" || !this.mobile) {
          layer.open({
            content: "请输入手机号!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.hospital == "" || !this.hospital) {
          layer.open({
            content: "请输入医院名称!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.image.length <= 0 || !this.image) {
          layer.open({
            content: "请上传作品图片!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.title == "" || !this.title) {
          layer.open({
            content: "请输入标题!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.content == "" || !this.content) {
          layer.open({
            content: "请输入描述!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        return true;
      },
      //删除图片
      endFun(index) {
        this.image.splice(index, 1);
      },
      //   上传图片
      handleChange(e) {
        let that = this;
        let images = "";
        var reader = new FormData();
        reader.append("file", e.target.files[0]);
        var layerOpen = layer.open({
          type: 2,
          content: "上传中。。。",
        });

        //发送图片消息
        $.ajax({
          type: "POST", //提交方式
          url: this.$URL + "upload", //路径
          data: reader,
          processData: false,
          contentType: false,
          success: function (result) {
            //返回数据根据结果进行相应的处理
            layer.close(layerOpen);
            if (result.data) {
              that.image.push(result.data);
              that.$nextTick(() => {
                that.addImg();
              });
            }
          },
        });
      },
      shutDown() {
        // this.$emit("shutDownFun");
        if (window.history.length > 2) {
          this.$router.go(-1);
        } else {
          this.$router.replace("/");
        }
      },
      addImg() {
        $(".li_r_img img").on("click", function () {
           
          $(this).ImgZoomIn("");
        });
      },
      detailsFun(id) {
        //查看详情
        this.$router.push({
          path: "/column_details",
          query: { id: id, head_index: 2 },
        });
      },
      getHotList() {
        //获取热门列表数据
        let that = this;
        this.$post("news_recomm", {
          type: 4,
          limit: 10,
          page: 1,
        }).then((res) => {
          let data = res.data.data;
          that.hotList_arr = data;
        });
      },
    },
    created() { },
    mounted() {
      this.head_index = this.$route.query.head_index;
      this.id = this.$route.query.id;
      this.getHotList();
      if(this.USER()){//用户数据赋值
        this.name = this.USER().realname?this.USER().realname:'';
        this.mobile = this.USER().mobile?this.USER().mobile:'';
        this.hospital = this.USER().company?this.USER().company:'';
      }
      if (this._isMobile()) {
        // alert("手机端");
        this.$router.push({ path: '/m_activity', query: { id: this.id } });
      } else {
        // alert("pc端");
        // this.$router.replace('/index');
      }
    },
  };
</script>
<style>
</style>
<style scoped>
  .main {
    max-width: 1280px;
    min-width: 865px;
    margin: 0 auto;
    width: 1280px;
    padding: 13px 0;
    align-items: flex-start;
    position: relative;
  }

  #index {
    background: #f5f3fb;
    min-width: 1280px;
  }

  .activitiesForm {
    width: 795px;
    background: #fff;
    border-radius: 10px;
    padding: 20px 51px;
  }

  /* 基本信息 */
  .div_li {
    margin-bottom: 50px;
  }

  .form_div {
    padding: 20px 0 20px 26px;
  }

  .form_title {
    font-size: 21px;
    color: #2b2b2b;
    font-weight: bold;
  }
  .form_title .f_title{
    font-size: 16px;
    color:#666;
    margin-left:4px;
    font-weight: normal;
  }
  .form_div .form_input {
    padding: 15px 0;
    align-items: center;
  }

  .form_div .form_input .input_title {
    margin-right: 32px;
    font-size: 19.23px;
    color: #888;
    white-space: nowrap;
  }

  .form_div .form_input .input_title>span {
    display: inline-block;
    text-align-last: justify;
    width: 60px;
  }

  .form_div .form_input .input_div {
    height: 37.8px;
    flex: 1;
    border: 1px solid #DFDFDF;
  }

  .form_div .form_input .input_div input {
    width: calc(100% - 12px);
    height: 100%;
    font-size: 15.8px;
    padding: 0 6px;
  }

  .img_div {
    padding: 35px 15px 22px 15px;
    align-items: center;
  }

  .img_div>.img_li {
    width: calc(25% - 24px);
    display: inline-flex;
    margin: 0 11px;

    position: relative;
  }

  .img_div>.img_li .img_li_div {
    width: 100%;
    max-height: 202px;
    overflow: hidden;
  }

  .img_div>.img_li .end_icon {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    width: 25px;
    height: 25px;
    cursor: pointer;
  }

  .img_div>.img_li>input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: inline-block;
    width: 100%;
    padding: 0;
    bottom: 0;
    opacity: 0;
  }

  .describe {
    font-size: 15.8px;
    color: #888;
    padding-left: 26px;
  }

  .textarea_div {
    margin-top: 20px;
    flex: 1;
  }

  .textarea_div textarea {
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    padding: 6px;
    border: 0;
    min-height: 329px;
    font-size: 15.8px;
    border: 1px solid #DFDFDF;
  }

  .button_div {
    margin-top: 50px;
    /* position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    height: 80px;
    right: 0;
    box-shadow: -2px 0 10px rgba(0,0,0,.1); */
  }
  /* .button_div>.mian{
    margin: 0 auto;
  } */
  .button_div .submit {
    width: 135px;
    height: 35.8px;
    line-height: 35.8px;
    border: 0;
    background: #f24d5b;
    border-radius: 5px;
    color: #fff;
    font-size: 15.7px;
    cursor: pointer;
  }

  .button_div .submit span {
    width: 46px;
    line-height: 1em;
    text-align-last: justify;
  }

  .button_div .return {
    background: #fff;
    color: #7f7e7e;
    border: 1px solid #DFDFDF;
    font-size: 15.7px;
    margin-left: 20px;
  }
  
    /* 热门 */
    .hot {
        width: 334px;
        background: #fff;
        border-radius: 10px;
        position: absolute;
        /* right: calc((100% - 1280px) / 2); */
        right: 0;
        top: 13px;
    }

    .hot .hot_title {
        border-bottom: 0.005rem solid #999999;
    }

    .hot .hot_title>i {
        width: 15px;
        margin-right: 11px;
    }

    .hot .hot_title>span {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        height: 70px;
    }

</style>


// WEBPACK FOOTER //
// src/components/pcActivity/activitiesForm.vue